/* 近代化資金の詳細画面の戻るボタン */
import React from 'react';
import TransitionButton from './TransitionButton';

const ModernizationFundsReturnButton: React.FC = () => {
  return (
    <div className="footer-button-group">
      <TransitionButton
        label="戻る"
        handleClick={() => {
          location.replace(document.referrer);
        }}
      />
    </div>
  );
};

export default ModernizationFundsReturnButton;
